import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CTAButtonProps = {
  children: React.ReactNode;
  className?: string;
  ariaLabel?: string;
};
const checkoutUrl = 'https://protocolo.impultienda.ar/checkout/oraculo';
export function CTAButton({
  children,
  className = '',
  ariaLabel
}: CTAButtonProps) {
  return <a href={checkoutUrl} aria-label={ariaLabel} className={`group inline-flex w-full items-center justify-center gap-2 rounded-sm bg-[#6D28D9] px-5 py-4 text-center text-sm font-bold uppercase tracking-[0.06em] text-white transition-colors duration-200 hover:bg-[#5B21B6] focus:outline-none focus:ring-4 focus:ring-[#DCCAF7] active:bg-[#4C1D95] ${className}`} data-id="element-34" data-mp="2fyk07ck7vuh9">
      <span data-id="element-35" data-mp="2ypt7rgafg967">{children}</span>
      <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" data-id="element-36" data-mp="2yql2yq0444vy" />
    </a>;
}